document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('nav-visible');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('no-scroll', open);
    });
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      nav.classList.remove('nav-visible');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('no-scroll');
    }));
  }

  const filterButtons = document.querySelectorAll('[data-product-filter]');
  const cards = document.querySelectorAll('.collection-section .product-card');
  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const selected = button.dataset.productFilter;
      filterButtons.forEach((item) => item.classList.toggle('active', item === button));
      cards.forEach((card) => card.classList.toggle('is-filtered-out', selected !== 'all' && card.dataset.productType !== selected));
    });
  });

  document.querySelectorAll('.quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('.quick-add');
      const label = form.querySelector('[data-quick-add-label]');
      if (!button || button.disabled) return;
      button.disabled = true;
      if (label) label.textContent = 'Ajout…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Ajout impossible');
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        if (label) label.textContent = 'Ajouté';
        showToast('La pièce a été ajoutée au panier.');
      } catch (error) {
        if (label) label.textContent = 'Réessayer';
        showToast('Impossible d’ajouter cette pièce pour le moment.');
      } finally {
        window.setTimeout(() => {
          button.disabled = false;
          if (label) label.textContent = 'Ajouter au panier';
        }, 1800);
      }
    });
  });

  function showToast(message) {
    document.querySelector('.toast-message')?.remove();
    const toast = document.createElement('div');
    toast.className = 'toast-message';
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);
    window.setTimeout(() => toast.remove(), 2800);
  }

  /* ---- Galerie produit : vignettes + zoom au survol ---- */
  const gallery = document.querySelector('.product-gallery--pro');
  if (gallery) {
    const slides = gallery.querySelectorAll('.product-gallery__slide');
    const thumbs = gallery.querySelectorAll('.product-gallery__thumb');

    const activate = (index) => {
      slides.forEach((slide) => slide.classList.toggle('is-active', Number(slide.dataset.index) === index));
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', Number(thumb.dataset.thumb) === index));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => activate(Number(thumb.dataset.thumb)));
      thumb.addEventListener('mouseenter', () => activate(Number(thumb.dataset.thumb)));
    });

    const isTouch = window.matchMedia('(hover: none)').matches;
    if (!isTouch) {
      slides.forEach((slide) => {
        slide.addEventListener('mousemove', (event) => {
          const rect = slide.getBoundingClientRect();
          slide.style.setProperty('--zoom-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
          slide.style.setProperty('--zoom-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
          slide.classList.add('is-zoomed');
        });
        slide.addEventListener('mouseleave', () => slide.classList.remove('is-zoomed'));
      });
    }
  }

  /* ---- Banniere dynamique : diaporama ---- */
  const hero = document.querySelector('[data-hero-slider]');
  if (hero) {
    const slides = hero.querySelectorAll('.hero-slide');
    const dots = hero.querySelectorAll('.hero-dot');
    const hasVideo = !!hero.querySelector('.hero-slide--video');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer = null;

    const show = (index) => {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      current = index;
    };

    const start = () => {
      if (reduce || hero.dataset.autoplay !== 'true') return;
      const total = slides.length;
      if (total < 2) return;
      const delay = Number(hero.dataset.speed) || 6000;
      clearInterval(timer);
      timer = setInterval(() => show((current + 1) % total), delay);
    };

    if (hasVideo && slides.length < 2) {
      // video seule : rien a faire
    } else {
      dots.forEach((dot) => dot.addEventListener('click', () => {
        show(Number(dot.dataset.goto));
        start();
      }));
      start();
      hero.addEventListener('mouseenter', () => clearInterval(timer));
      hero.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) clearInterval(timer); else start();
      });
    }
  }

  /* ============ MODULE DE PERSONNALISATION — apercu reel sur cuir ============ */
  const perso = document.querySelector('[data-perso]');
  if (perso) {
    const cv      = perso.querySelector('[data-perso-canvas-el]');
    const ctx     = cv ? cv.getContext('2d') : null;
    const txtEl   = perso.querySelector('[data-perso-input]');
    const monoEl  = perso.querySelector('[data-perso-mono]');
    const render  = perso.querySelector('[data-perso-render]');
    const leather = perso.querySelector('.perso-leather');
    const fileIn  = perso.querySelector('[data-perso-file]');
    const fileName= perso.querySelector('[data-perso-filename]');
    const depth   = perso.querySelector('[data-perso-depth]');

    const CUIRS = {
      'Cognac':      ['#8B5E3C','#6B4226','#5A3720'],
      'Noir profond':['#2B1D14','#1E140E','#171009'],
      'Tabac':       ['#9C6B44','#7A4F2E','#63401F'],
      'Espresso':    ['#6B4226','#4E2E1A','#3A2213']
    };
    const FONTS = {
      'Serif classique':'Georgia,"Times New Roman",serif',
      'Sans-serif moderne':'Helvetica,Arial,sans-serif',
      'Manuscrite':'"Segoe Script","Bradley Hand",cursive',
      'Majuscules espacées':'Georgia,serif'
    };
    let photoImg = null;
    let photoBW  = null;

    const q = (sel) => perso.querySelector(sel);
    const checked = (sel) => { const e = perso.querySelector(sel + ' input:checked'); return e ? e.value : ''; };

    /* --- Grain du cuir : dessine une texture procedurale --- */
    function drawLeather(cuir) {
      if (!ctx) return;
      const c = CUIRS[cuir] || CUIRS['Cognac'];
      const w = cv.width, h = cv.height;
      const g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, c[0]); g.addColorStop(0.55, c[1]); g.addColorStop(1, c[2]);
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);

      // grain fin
      const img = ctx.getImageData(0, 0, w, h);
      const d = img.data;
      for (let i = 0; i < d.length; i += 4) {
        const n = (Math.random() - 0.5) * 26;
        d[i] += n; d[i+1] += n; d[i+2] += n;
      }
      ctx.putImageData(img, 0, 0);

      // pores
      ctx.globalAlpha = 0.10;
      for (let i = 0; i < 900; i++) {
        ctx.beginPath();
        ctx.arc(Math.random()*w, Math.random()*h, Math.random()*2.2, 0, Math.PI*2);
        ctx.fillStyle = Math.random() > 0.5 ? '#000' : '#fff';
        ctx.fill();
      }
      ctx.globalAlpha = 1;

      // lumiere
      const rg = ctx.createRadialGradient(w*0.32, h*0.28, 10, w*0.32, h*0.28, w*0.75);
      rg.addColorStop(0, 'rgba(255,255,255,0.10)');
      rg.addColorStop(1, 'rgba(0,0,0,0.22)');
      ctx.fillStyle = rg; ctx.fillRect(0, 0, w, h);
    }

    /* --- Convertit une photo en motif de gravure (traits opaques sur fond transparent) --- */
    function makeEngraving(img, mode) {
      const W = 420, H = Math.max(1, Math.round(W * img.height / img.width));
      const off = document.createElement('canvas');
      off.width = W; off.height = H;
      const o = off.getContext('2d');
      o.drawImage(img, 0, 0, W, H);
      const data = o.getImageData(0, 0, W, H);
      const d = data.data;

      // passage en niveaux de gris
      for (let i = 0; i < d.length; i += 4) {
        const v = 0.299 * d[i] + 0.587 * d[i+1] + 0.114 * d[i+2];
        d[i] = d[i+1] = d[i+2] = v;
      }

      if (mode === 'trait') {
        // seuil : les zones sombres deviennent des traits opaques, le reste transparent
        for (let i = 0; i < d.length; i += 4) {
          const on = d[i] < 140;
          d[i+3] = on ? 255 : 0;
          if (on) { d[i] = 255; d[i+1] = 255; d[i+2] = 255; }   // blanc = sera teinte
        }
      } else {
        // demi-teintes : trame de points (rendu gravure laser)
        const cell = 3;
        for (let y = 0; y < H; y++) {
          for (let x = 0; x < W; x++) {
            const i = (y*W + x) * 4;
            const v = d[i];
            const gx = x % cell, gy = y % cell;
            const dotR = (1 - v/255) * (cell * 0.75);
            const dist = Math.hypot(gx - cell/2, gy - cell/2);
            const on = dist <= dotR;
            d[i+3] = on ? 255 : 0;
            if (on) { d[i] = 255; d[i+1] = 255; d[i+2] = 255; }
          }
        }
      }
      o.putImageData(data, 0, 0);
      return off;
    }

    /* --- Teinte le motif avec une couleur (canvas offscreen, composition isolee) --- */
    function tint(motif, color) {
      const c = document.createElement('canvas');
      c.width = motif.width; c.height = motif.height;
      const x = c.getContext('2d');
      x.drawImage(motif, 0, 0);
      x.globalCompositeOperation = 'source-in';   // agit uniquement sur ce canvas
      x.fillStyle = color;
      x.fillRect(0, 0, c.width, c.height);
      return c;
    }

    /* --- Dessine la gravure photo sur le cuir --- */
    function drawPhoto() {
      if (!ctx || !photoImg || !photoBW) return;
      const w = cv.width, h = cv.height;
      const scale = Math.min(w * 0.46 / photoBW.width, h * 0.46 / photoBW.height);
      const pw = photoBW.width * scale, ph = photoBW.height * scale;
      const px = (w - pw) / 2, py = (h - ph) / 2;

      const foil = checked('[data-perso-method]').indexOf('foil') > -1;
      const fin  = checked('[data-perso-foil]');
      const prof = depth ? Number(depth.value) / 100 : 0.5;

      ctx.save();

      if (foil) {
        // DORURE : feuille metallique
        const MAP = { 'Or': '#E9CE79', 'Argent': '#E4E6E8', 'Cuivre': '#F0B584', 'Ton sur ton': '#B08A62' };
        const col = MAP[fin] || '#E9CE79';
        // halo lumineux
        ctx.globalAlpha = 0.35;
        ctx.shadowColor = col; ctx.shadowBlur = 26;
        ctx.drawImage(tint(photoBW, col), px, py, pw, ph);
        ctx.shadowBlur = 0;
        // corps du foil
        ctx.globalAlpha = 0.95;
        ctx.drawImage(tint(photoBW, col), px, py, pw, ph);
        // relief : leger decalage sombre
        ctx.globalAlpha = 0.22 * (0.6 + prof);
        ctx.drawImage(tint(photoBW, '#1a1008'), px + 1.2, py + 1.4, pw, ph);
      } else {
        // LASER CO2 : marquage en creux, ton plus sombre que le cuir
        const creux = '#3A2314';
        ctx.globalAlpha = 0.30 + prof * 0.45;
        ctx.drawImage(tint(photoBW, creux), px, py, pw, ph);
        // bord de brulure
        ctx.globalAlpha = 0.18;
        ctx.drawImage(tint(photoBW, '#1a0f07'), px + 1, py + 1.2, pw, ph);
        // leger reflet dans le creux
        ctx.globalAlpha = 0.10;
        ctx.drawImage(tint(photoBW, '#ffffff'), px - 0.8, py - 0.8, pw, ph);
      }

      ctx.globalAlpha = 1;
      ctx.restore();
    }

    /* --- Rafraichit tout l'apercu --- */
    function refresh() {
      const mode  = checked('[data-perso-mode]');
      const cuir  = checked('[data-perso-leather-pick]');
      const foil  = checked('[data-perso-method]').indexOf('foil') > -1;
      const fin   = checked('[data-perso-foil]');
      const style = checked('[data-perso-style]');

      // panneaux
      perso.querySelectorAll('[data-panel]').forEach((p) => {
        const k = p.dataset.panel;
        const on = (k === 'texte' && mode === 'Texte') || (k === 'photo' && mode === 'Photo ou logo') || (k === 'mono' && mode === 'Monogramme');
        p.classList.toggle('is-active', on);
      });
      // le style de police ne sert qu'au texte/monogramme
      const sw = q('[data-perso-style-wrap]');
      if (sw) sw.style.display = (mode === 'Photo ou logo') ? 'none' : '';

      // fond du cuir (canvas + couleur de secours)
      chargerCuir(cuir);
      if (leather) {
        const c = CUIRS[cuir] || CUIRS['Cognac'];
        leather.style.background = 'linear-gradient(145deg,' + c[0] + ',' + c[1] + ' 55%,' + c[2] + ')';
        leather.dataset.leather = cuir;
      }

      // texte ou monogramme (DOM)
      const isPhoto = mode === 'Photo ou logo';
      if (render) {
        if (mode === 'Monogramme') {
          render.textContent = (monoEl && monoEl.value.trim()) || 'ABD';
        } else {
          render.textContent = (txtEl && txtEl.value.trim()) || 'Votre texte';
        }
        render.style.display = isPhoto ? 'none' : '';
        render.classList.toggle('is-foil', !!foil);
        render.dataset.fin = fin;
        const f = FONTS[style] || FONTS['Serif classique'];
        render.style.fontFamily = f;
        render.style.letterSpacing = (style === 'Majuscules espacées') ? '.18em' : 'normal';
        render.style.textTransform = (style === 'Majuscules espacées') ? 'uppercase' : 'none';
        if (mode === 'Monogramme') { render.style.fontSize = 'clamp(30px,5vw,54px)'; render.style.letterSpacing = '.08em'; }
        else { render.style.fontSize = ''; }
      }

      // photo
      if (isPhoto) drawPhoto();
    }

    /* --- Lecture du fichier --- */
    if (fileIn) {
      fileIn.addEventListener('change', () => {
        const f = fileIn.files && fileIn.files[0];
        if (!f) return;
        if (fileName) fileName.textContent = f.name;
        if (f.size > 5 * 1024 * 1024) {
          if (fileName) fileName.textContent = f.name + ' — fichier trop lourd (5 Mo max)';
          return;
        }
        const r = new FileReader();
        r.onload = (e) => {
          const im = new Image();
          im.onload = () => { photoImg = im; photoBW = makeEngraving(im, 'trait'); refresh(); };
          im.src = e.target.result;
        };
        r.readAsDataURL(f);
      });
    }

    /* --- Evenements --- */
    perso.querySelectorAll('[data-perso-mode],[data-perso-method],[data-perso-foil],[data-perso-style],[data-perso-treat],[data-perso-leather-pick]').forEach((g) => {
      g.addEventListener('change', () => {
        g.querySelectorAll('label').forEach((l) => l.classList.toggle('is-active', !!l.querySelector('input:checked')));
        // re-generer la gravure si le traitement change
        if (g.hasAttribute('data-perso-treat') && photoImg) photoBW = makeEngraving(photoImg, checked('[data-perso-treat]').indexOf('Demi') > -1 ? 'demi' : 'trait');
        refresh();
      });
    });
    if (txtEl)  txtEl.addEventListener('input', refresh);
    if (monoEl) monoEl.addEventListener('input', refresh);
    if (depth)  depth.addEventListener('input', refresh);

    const rst = q('[data-perso-reset]');
    if (rst) rst.addEventListener('click', () => {
      photoImg = null; photoBW = null;
      if (fileIn) fileIn.value = '';
      if (fileName) fileName.textContent = 'Aucun fichier sélectionné';
      if (txtEl) txtEl.value = '';
      if (monoEl) monoEl.value = '';
      perso.querySelectorAll('input[type=radio]').forEach((r) => { r.checked = (r.defaultChecked); });
      perso.querySelectorAll('label').forEach((l) => l.classList.toggle('is-active', !!l.querySelector('input:checked')));
      if (depth) depth.value = 50;
      refresh();
    });

    refresh();
  }

  /* ============ CONSENTEMENT COOKIES (RGPD) ============ */
  (function () {
    const KEY = 'crealux_consent_v1';
    const box = document.querySelector('[data-ck]:not([data-ck-guard])');
    if (box) box.setAttribute('data-ck-guard', '1');
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }

    // Applique le consentement : active/desactive les scripts marques
    function apply(consent) {
      document.querySelectorAll('script[type="text/plain"][data-consent]').forEach((s) => {
        const cat = s.getAttribute('data-consent');
        if (consent[cat]) {
          const n = document.createElement('script');
          if (s.src) { n.src = s.src; n.async = true; } else { n.textContent = s.textContent; }
          s.parentNode.replaceChild(n, s);
        }
      });
      window.crealuxConsent = consent;
      document.dispatchEvent(new CustomEvent('crealux:consent', { detail: consent }));
    }

    if (saved) { apply(saved); if (box) box.hidden = true; return; }

    // Premier passage : on affiche le bandeau, rien n'est charge avant le choix
    if (!box) return;
    setTimeout(() => { box.hidden = false; }, 900);

    const detail = box.querySelector('[data-ck-detail]');
    const close = (consent) => {
      try { localStorage.setItem(KEY, JSON.stringify(consent)); } catch (e) {}
      apply(consent);
      box.hidden = true;
    };

    box.querySelector('[data-ck-accept]').addEventListener('click', () => close({ necessary: true, analytics: true, marketing: true }));
    box.querySelector('[data-ck-refuse]').addEventListener('click', () => close({ necessary: true, analytics: false, marketing: false }));
    box.querySelector('[data-ck-custom]').addEventListener('click', () => {
      if (detail.hidden) { detail.hidden = false; box.querySelector('[data-ck-custom]').textContent = 'Enregistrer mes choix'; }
      else {
        close({
          necessary: true,
          analytics: !!(box.querySelector('[data-ck-cat="analytics"]') || {}).checked,
          marketing: !!(box.querySelector('[data-ck-cat="marketing"]') || {}).checked
        });
      }
    });
  })();

  /* ============ POP-UP NEWSLETTER ============ */
  (function () {
    const pop = document.querySelector('[data-nl-pop]');
    if (!pop) return;
    const KEY = 'crealux_nl_seen';
    try { if (localStorage.getItem(KEY)) return; } catch (e) {}

    const delay = (Number(pop.dataset.delay) || 8) * 1000;
    let shown = false;

    const open = () => {
      if (shown) return;
      shown = true;
      pop.hidden = false;
      document.body.style.overflow = 'hidden';
      const f = pop.querySelector('input[type=email]');
      if (f) setTimeout(() => f.focus(), 350);
    };
    const shut = () => {
      pop.hidden = true;
      document.body.style.overflow = '';
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    };

    setTimeout(open, delay);
    // declenchement aussi si le visiteur s'apprete a partir
    document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 10) open(); });

    pop.querySelectorAll('[data-nl-close]').forEach((b) => b.addEventListener('click', shut));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) shut(); });
  })();

  /* ============ CAMPAGNE — apparition au scroll (discret) ============ */
  (function () {
    const items = document.querySelectorAll('.cmp-reveal');
    if (!items.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    items.forEach((el) => obs.observe(el));
  })();

  /* ============ EDITEUR DE PERSONNALISATION — temps reel ============ */
  (function () {
    const pe = document.querySelector('[data-pe]');
    if (!pe) return;

    const photoEl = pe.querySelector('[data-pe-photo]');
    const leather = pe.querySelector('[data-pe-leather]');
    const layer   = pe.querySelector('[data-pe-layer]');
    const render  = pe.querySelector('[data-pe-render]');
    const hint    = pe.querySelector('[data-pe-hint]');
    const fileIn  = pe.querySelector('[data-pe-file]');
    const fileName= pe.querySelector('[data-pe-filename]');
    const freeChk = pe.querySelector('[data-pe-free]');
    const placeIn = pe.querySelector('[data-pe-place-input]');

    const CUIRS = {
      'Cognac':   ['#8B5E3C','#6B4226','#5A3720'],
      'Noir':     ['#2B1D14','#1E140E','#171009'],
      'Tabac':    ['#9C6B44','#7A4F2E','#63401F'],
      'Espresso': ['#6B4226','#4E2E1A','#3A2213']
    };
    const FONTS = {
      'Serif':      'Georgia,"Times New Roman",serif',
      'Sans-serif': 'Helvetica,Arial,sans-serif',
      'Manuscrite': '"Segoe Script","Bradley Hand",cursive',
      'Capitales':  'Georgia,serif'
    };
    // Positions en % de la zone personnalisable
    const PLACES = {
      'centre':      [50, 52],
      'haut-gauche': [22, 22],
      'haut-droit':  [78, 22],
      'bas-gauche':  [22, 80],
      'bas-droit':   [78, 80],
      'poignee':     [50, 13],
      'poche':       [72, 62],
      'dos':         [50, 88],
      'interieur':   [50, 40]
    };

    let pos = { x: 50, y: 52 };
    let photoImg = null, photoBW = null;

    const val = (sel) => { const e = pe.querySelector(sel + ' input:checked'); return e ? e.value : ''; };

    /* --- Photo de cuir : 4 matieres reelles --- */
    const PHOTOS = {
      'Cognac':   'cuir-cognac.jpg',
      'Noir':     'cuir-noir.jpg',
      'Tabac':    'cuir-tabac.jpg',
      'Espresso': 'cuir-espresso.jpg'
    };
    let photoCuir = null;

    /* Les URLs d'assets sont ecrites dans le DOM par Liquid (asset_url), ce qui
       evite de deviner le numero de version du CDN : theme.id n'est PAS la
       version servie par /cdn/shop/t/<version>/, et produisait un 404. */
    const CUIR_URLS = (() => {
      const map = {};
      const nodes = document.querySelectorAll('[data-lx-cuir-url]');
      nodes.forEach((n) => { map[n.getAttribute('data-lx-cuir-url')] = n.getAttribute('data-lx-cuir-src'); });
      return map;
    })();

    function chargerCuir(nom) {
      if (!photoEl) return;
      const fichier = PHOTOS[nom] || PHOTOS['Cognac'];
      if (photoCuir && photoCuir === fichier) return;   // deja chargee
      photoCuir = fichier;
      const url = CUIR_URLS[fichier] || fichier;
      photoEl.style.opacity = '0';
      const pre = new Image();
      pre.onload = () => { photoEl.src = url; photoEl.style.opacity = '1'; };
      pre.onerror = () => { photoEl.style.opacity = '1'; };  // garde l'image actuelle
      pre.src = url;
    }

    /* --- Photo -> motif de gravure --- */
    function makeMotif(img, mode) {
      const W = 460, H = Math.max(1, Math.round(W * img.height / img.width));
      const off = document.createElement('canvas'); off.width = W; off.height = H;
      const o = off.getContext('2d');
      o.drawImage(img, 0, 0, W, H);
      const data = o.getImageData(0, 0, W, H), d = data.data;
      for (let i = 0; i < d.length; i += 4) {
        const v = .299*d[i] + .587*d[i+1] + .114*d[i+2];
        d[i] = d[i+1] = d[i+2] = v;
      }
      if (mode === 'trait') {
        for (let i = 0; i < d.length; i += 4) {
          const on = d[i] < 140;
          d[i+3] = on ? 255 : 0;
          if (on) { d[i] = d[i+1] = d[i+2] = 255; }
        }
      } else {
        const cell = 3;
        for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
          const i = (y*W + x) * 4, v = d[i];
          const dotR = (1 - v/255) * (cell * .75);
          const on = Math.hypot(x % cell - cell/2, y % cell - cell/2) <= dotR;
          d[i+3] = on ? 255 : 0;
          if (on) { d[i] = d[i+1] = d[i+2] = 255; }
        }
      }
      o.putImageData(data, 0, 0);
      return off;
    }
    function tint(motif, color) {
      const c = document.createElement('canvas');
      c.width = motif.width; c.height = motif.height;
      const x = c.getContext('2d');
      x.drawImage(motif, 0, 0);
      x.globalCompositeOperation = 'source-in';
      x.fillStyle = color; x.fillRect(0, 0, c.width, c.height);
      return c;
    }

    /* --- Applique position + rendu --- */
    function apply() {
      if (!render) return;
      const mode  = val('[data-pe-mode]');
      const font  = val('[data-pe-font]');
      const color = val('[data-pe-color]');
      const cuir  = val('[data-pe-leather]');
      const taille= Number((pe.querySelector('[data-pe-size]') || {}).value || 100);

      // Texte affiche
      if (mode === 'Monogramme') {
        render.textContent = (pe.querySelector('[data-pe-mono]') || {}).value || 'ABD';
      } else if (mode === 'Photo ou logo') {
        render.textContent = photoImg ? '' : 'Votre image';
      } else {
        render.textContent = (pe.querySelector('[data-pe-text]') || {}).value || 'Votre texte';
      }

      // Styles
      render.style.fontFamily = FONTS[font] || FONTS['Serif'];
      render.style.fontSize = (taille / 100 * 2.1) + 'vw';
      render.style.letterSpacing = (font === 'Capitales') ? '.16em' : 'normal';
      render.style.textTransform = (font === 'Capitales') ? 'uppercase' : 'none';

      // Couleur + effet grave
      const FOIL = { 'Or':'#E9CE79', 'Argent':'#E4E6E8', 'Cuivre':'#F0B584' };
      render.dataset.col = color;
      render.classList.toggle('is-foil', !!FOIL[color]);
      if (FOIL[color]) {
        render.style.color = FOIL[color];
        render.style.textShadow = '0 0 16px ' + FOIL[color] + '99, 0 1px 2px rgba(0,0,0,.55), 0 -1px 0 rgba(255,255,255,.35)';
      } else if (color === 'Naturel') {
        render.style.color = '#EADFCB';
        render.style.textShadow = '0 1px 1px rgba(0,0,0,.5), 0 -1px 0 rgba(255,255,255,.18)';
      } else {
        render.style.color = '#150F0A';
        render.style.textShadow = '0 -1px 0 rgba(255,255,255,.22), 0 1px 1px rgba(0,0,0,.62), 0 0 1px rgba(0,0,0,.5)';
      }

      // Position
      layer.style.left = pos.x + '%';
      layer.style.top  = pos.y + '%';
      layer.style.transform = 'translate(-50%,-50%)';

      // Cuir
      leather.dataset.cuir = cuir;
      chargerCuir(cuir);

      // Panneaux
      pe.querySelectorAll('[data-pe-panel]').forEach((p) => {
        const k = p.dataset.pePanel;
        p.hidden = !((k === 'texte' && mode === 'Texte') || (k === 'mono' && mode === 'Monogramme') || (k === 'photo' && mode === 'Photo ou logo'));
      });

      // Resume
      const set = (k, v) => { const e = pe.querySelector('[data-sum="' + k + '"]'); if (e) e.textContent = v; };
      set('type', mode);
      set('texte', mode === 'Monogramme' ? (pe.querySelector('[data-pe-mono]') || {}).value : (mode === 'Photo ou logo' ? (photoImg ? 'Image envoyee' : '—') : (pe.querySelector('[data-pe-text]') || {}).value));
      set('font', font); set('color', color); set('leather', cuir);
      const actif = pe.querySelector('.pe-place.is-active');
      set('place', freeChk && freeChk.checked ? 'Position personnalisee' : (actif ? actif.textContent : 'Centre'));
      if (placeIn) placeIn.value = freeChk && freeChk.checked ? 'Position personnalisee' : (actif ? actif.textContent : 'Centre');
      if (hint) hint.hidden = !(freeChk && freeChk.checked);
    }

    /* --- Emplacements --- */
    pe.querySelectorAll('.pe-place[data-pos]').forEach((btn) => {
      btn.addEventListener('click', () => {
        pe.querySelectorAll('.pe-place').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (freeChk) freeChk.checked = false;
        const p = PLACES[btn.dataset.pos] || PLACES['centre'];
        pos = { x: p[0], y: p[1] };
        layer.classList.add('is-moving');
        setTimeout(() => { layer.classList.remove('is-moving'); }, 460);
        apply();
      });
    });

    /* --- Glisser-deposer (souris + tactile) --- */
    function clamp(v) { return Math.max(6, Math.min(94, v)); }
    let drag = false;
    const canvasBox = pe.querySelector('[data-pe-canvas]');

    const moveTo = (clientX, clientY) => {
      const r = canvasBox.getBoundingClientRect();
      pos.x = clamp(((clientX - r.left) / r.width) * 100);
      pos.y = clamp(((clientY - r.top) / r.height) * 100);
      layer.style.left = pos.x + '%';
      layer.style.top = pos.y + '%';
    };
    const start = (e) => {
      if (!freeChk || !freeChk.checked) return;
      drag = true;
      leather.classList.add('is-dragging');
      layer.classList.remove('is-moving');
      const t = e.touches ? e.touches[0] : e;
      moveTo(t.clientX, t.clientY);
      e.preventDefault();
    };
    const move = (e) => {
      if (!drag) return;
      const t = e.touches ? e.touches[0] : e;
      moveTo(t.clientX, t.clientY);
      e.preventDefault();
    };
    const end = () => { if (drag) { drag = false; leather.classList.remove('is-dragging'); apply(); } };

    if (canvasBox) {
      canvasBox.addEventListener('mousedown', start);
      canvasBox.addEventListener('touchstart', start, { passive: false });
      document.addEventListener('mousemove', move);
      document.addEventListener('touchmove', move, { passive: false });
      document.addEventListener('mouseup', end);
      document.addEventListener('touchend', end);
    }

    if (freeChk) freeChk.addEventListener('change', () => {
      if (freeChk.checked) {
        pe.querySelectorAll('.pe-place').forEach((b) => b.classList.remove('is-active'));
        leather.classList.add('is-free');
      } else {
        const first = pe.querySelector('.pe-place[data-pos="centre"]');
        if (first) first.classList.add('is-active');
        pos = { x: 50, y: 52 };
        leather.classList.remove('is-free');
      }
      apply();
    });

    /* --- Ecouteurs --- */
    pe.querySelectorAll('[data-pe-mode],[data-pe-font],[data-pe-color],[data-pe-leather]').forEach((g) => {
      g.addEventListener('change', () => {
        g.querySelectorAll('label').forEach((l) => l.classList.toggle('is-active', !!l.querySelector('input:checked')));
        apply();
      });
    });
    ['[data-pe-text]','[data-pe-mono]'].forEach((s) => {
      const el = pe.querySelector(s);
      if (el) el.addEventListener('input', apply);
    });
    const sizeEl = pe.querySelector('[data-pe-size]');
    if (sizeEl) sizeEl.addEventListener('input', apply);

    /* --- Fichier --- */
    if (fileIn) fileIn.addEventListener('change', () => {
      const f = fileIn.files && fileIn.files[0];
      if (!f) return;
      if (fileName) fileName.textContent = f.name;
      if (f.size > 5 * 1024 * 1024) { if (fileName) fileName.textContent = f.name + ' — trop lourd (5 Mo max)'; return; }
      const r = new FileReader();
      r.onload = (e) => {
        const im = new Image();
        im.onload = () => {
          photoImg = im;
          photoBW = makeMotif(im, 'trait');
          // afficher l'image dans l'apercu
          const url = tint(photoBW, '#1A1410').toDataURL();
          render.textContent = '';
          render.style.backgroundImage = 'url(' + url + ')';
          render.style.backgroundSize = 'contain';
          render.style.backgroundRepeat = 'no-repeat';
          render.style.backgroundPosition = 'center';
          render.style.width = '26%';
          render.style.height = '26%';
          apply();
        };
        im.src = e.target.result;
      };
      r.readAsDataURL(f);
    });

    /* --- Reset --- */
    const rst = pe.querySelector('[data-pe-reset]');
    if (rst) rst.addEventListener('click', () => {
      photoImg = null; photoBW = null;
      if (fileIn) fileIn.value = '';
      if (fileName) fileName.textContent = 'Aucun fichier selectionne';
      pe.querySelectorAll('input[type=radio]').forEach((r) => { r.checked = r.defaultChecked; });
      pe.querySelectorAll('label').forEach((l) => l.classList.toggle('is-active', !!l.querySelector('input:checked')));
      const t = pe.querySelector('[data-pe-text]'); if (t) t.value = 'ANTOINE';
      const m = pe.querySelector('[data-pe-mono]'); if (m) m.value = 'ABD';
      if (sizeEl) sizeEl.value = 100;
      if (freeChk) freeChk.checked = false;
      pe.querySelectorAll('.pe-place').forEach((b) => b.classList.toggle('is-active', b.dataset.pos === 'centre'));
      pos = { x: 50, y: 52 };
      render.style.backgroundImage = '';
      render.style.width = ''; render.style.height = '';
      apply();
    });

    apply();
  })();

  /* ============ LX — HOMEPAGE : interactions ============ */
  (function () {

    /* --- 1. Header transparent -> opaque au scroll --- */
    const hdr = document.querySelector('.site-header.global-header');
    if (hdr) {
      hdr.classList.add('lx-header');
      const onScroll = () => hdr.classList.toggle('is-scrolled', window.scrollY > 60);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* --- 2. Hero : campagnes dynamiques --- */
    const hero = document.querySelector('[data-lx-hero]');
    if (hero) {
      const slides  = hero.querySelectorAll('.lx-hero__slide');
      const panels  = hero.querySelectorAll('.lx-hero__content');
      const dots    = hero.querySelectorAll('.lx-dot');
      let cur = 0, timer = null;
      const delay = Number(hero.dataset.speed) || 8000;

      const show = (i) => {
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        panels.forEach((p, k) => p.classList.toggle('is-active', k === i));
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        cur = i;
      };
      const start = () => {
        if (slides.length < 2) return;
        clearInterval(timer);
        timer = setInterval(() => show((cur + 1) % slides.length), delay);
      };
      dots.forEach((d) => d.addEventListener('click', () => { show(Number(d.dataset.goto)); start(); }));
      hero.addEventListener('mouseenter', () => clearInterval(timer));
      hero.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => document.hidden ? clearInterval(timer) : start());
      start();
    }

    /* --- 3. Collections : hover change l'image --- */
    const coll = document.querySelector('[data-lx-coll]');
    if (coll) {
      const imgs = coll.querySelectorAll('.lx-coll__img');
      const caps = coll.querySelectorAll('.lx-coll__caption');
      const items = coll.querySelectorAll('.lx-coll__item');
      const activer = (i) => {
        imgs.forEach((e, k) => e.classList.toggle('is-active', k === i));
        caps.forEach((e, k) => e.classList.toggle('is-active', k === i));
        items.forEach((e, k) => e.classList.toggle('is-active', k === i));
      };
      items.forEach((it, i) => {
        it.addEventListener('mouseenter', () => activer(i));
        it.addEventListener('focus', () => activer(i));
        it.addEventListener('click', (e) => { if (window.innerWidth <= 1024) { e.preventDefault(); activer(i); } });
      });
    }

    /* --- 4. Parallax tres leger --- */
    const px = document.querySelectorAll('[data-lx-parallax]');
    if (px.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let raf = null;
      const bouger = () => {
        raf = null;
        px.forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.bottom < -100 || r.top > window.innerHeight + 100) return;
          const prog = (window.innerHeight - r.top) / (window.innerHeight + r.height);
          const y = (prog - 0.5) * 42;
          const img = el.querySelector('img');
          if (img) img.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.08)';
        });
      };
      const onScroll = () => { if (!raf) raf = requestAnimationFrame(bouger); };
      window.addEventListener('scroll', onScroll, { passive: true });
      bouger();
    }

    /* --- 5. Apparition progressive --- */
    const rv = document.querySelectorAll('.lx-h2, .lx-text, .lx-card, .lx-eyebrow');
    if (rv.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      rv.forEach((el) => el.classList.add('lx-reveal'));
      const obs = new IntersectionObserver((es) => {
        es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      rv.forEach((el) => obs.observe(el));
    } else {
      rv.forEach((el) => el.classList.add('is-in'));
    }

    /* --- 6. Apercu personnalisation interactif --- */
    const lp = document.querySelector('[data-lx-perso]');
    if (lp) {
      const render  = document.querySelector('[data-lx-perso-render]');
      const layer   = document.querySelector('[data-lx-perso-layer]');
      const leather = document.querySelector('.lx-perso__leather');
      const canvas  = document.querySelector('[data-lx-perso-canvas]');
      const hint    = document.querySelector('[data-lx-perso-hint]');
      const champ   = document.querySelector('[data-lx-perso-text]');
      const POS = {
        'centre':[50,52],'haut-gauche':[24,22],'haut-droit':[76,22],
        'bas-gauche':[24,80],'bas-droit':[76,80],'poche':[72,62],'poignee':[50,14]
      };
      let libre = false, pos = { x: 50, y: 52 };

      const placer = (x, y, anime) => {
        layer.style.left = x + '%';
        layer.style.top  = y + '%';
        if (anime) { layer.classList.add('is-moving'); setTimeout(() => layer.classList.remove('is-moving'), 460); }
      };
      lp.querySelectorAll('[data-lx-perso-places] button').forEach((b) => {
        b.addEventListener('click', () => {
          lp.querySelectorAll('[data-lx-perso-places] button').forEach((x) => x.classList.remove('is-active'));
          b.classList.add('is-active');
          if (b.dataset.pos === 'libre') {
            libre = true;
            leather.classList.add('is-free');
            if (hint) hint.hidden = false;
          } else {
            libre = false;
            leather.classList.remove('is-free');
            if (hint) hint.hidden = true;
            const p = POS[b.dataset.pos] || POS['centre'];
            pos = { x: p[0], y: p[1] };
            placer(pos.x, pos.y, true);
          }
        });
      });
      if (champ && render) champ.addEventListener('input', () => {
        render.textContent = champ.value || 'Votre texte';
      });

      const clamp = (v) => Math.max(6, Math.min(94, v));
      let drag = false;
      const moveTo = (cx, cy) => {
        const r = canvas.getBoundingClientRect();
        pos.x = clamp(((cx - r.left) / r.width) * 100);
        pos.y = clamp(((cy - r.top) / r.height) * 100);
        placer(pos.x, pos.y, false);
      };
      const down = (e) => { if (!libre) return; drag = true; leather.classList.add('is-dragging'); const t = e.touches ? e.touches[0] : e; moveTo(t.clientX, t.clientY); e.preventDefault(); };
      const mv   = (e) => { if (!drag) return; const t = e.touches ? e.touches[0] : e; moveTo(t.clientX, t.clientY); e.preventDefault(); };
      const up   = () => { if (drag) { drag = false; leather.classList.remove('is-dragging'); } };
      canvas.addEventListener('mousedown', down);
      canvas.addEventListener('touchstart', down, { passive: false });
      document.addEventListener('mousemove', mv);
      document.addEventListener('touchmove', mv, { passive: false });
      document.addEventListener('mouseup', up);
      document.addEventListener('touchend', up);
    }
  })();

  /* ============ FICHE PRODUIT : galerie dynamique ============ */
  (function () {
    const main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    const slides = main.querySelectorAll('.product-gallery__slide');
    const thumbs = document.querySelectorAll('[data-thumb]');
    const prev = document.querySelector('[data-gallery-prev]');
    const next = document.querySelector('[data-gallery-next]');
    if (slides.length < 2) return;
    let cur = 0;

    const show = (i) => {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === cur));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === cur));
    };

    if (prev) prev.addEventListener('click', () => show(cur - 1));
    if (next) next.addEventListener('click', () => show(cur + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.thumb))));

    // Navigation clavier
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(cur - 1);
      if (e.key === 'ArrowRight') show(cur + 1);
    });

    // Swipe mobile
    let startX = 0;
    main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    // Zoom léger au survol
    slides.forEach((s) => {
      const img = s.querySelector('img');
      if (!img) return;
      s.addEventListener('mousemove', (e) => {
        const r = s.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width - 0.5) * 10;
        const y = ((e.clientY - r.top) / r.height - 0.5) * 10;
        img.style.transform = `scale(1.08) translate(${x}px, ${y}px)`;
      });
      s.addEventListener('mouseleave', () => { img.style.transform = ''; });
    });
  })();

  /* ============ MEGA MENU : interactions mobile ============ */
  (function () {
    const toggle = document.querySelector('[data-menu-toggle]');
    const nav = document.querySelector('[data-site-nav]');
    if (!toggle || !nav) return;

    // Toggle menu mobile
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });

    // Fermer en cliquant à l'extérieur
    document.addEventListener('click', (e) => {
      if (!nav.classList.contains('is-open')) return;
      if (nav.contains(e.target) || toggle.contains(e.target)) return;
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });

    // Fermer avec Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });

    // Sous-menus mobile (toggle au clic)
    const items = nav.querySelectorAll('.main-nav__item');
    items.forEach((item) => {
      const link = item.querySelector('.main-nav__link');
      const mega = item.querySelector('.mega-menu');
      if (!mega) return;
      link.addEventListener('click', (e) => {
        if (window.innerWidth <= 1024) {
          e.preventDefault();
          item.classList.toggle('is-open');
        }
      });
    });
  })();

  /* ============ PAGE PRODUIT atelier : interactions ============ */
  (function () {
    // Galerie : points de carrousel
    const main = document.querySelector('[data-gallery-main]');
    if (main) {
      const slides = main.querySelectorAll('.atelier-product__slide');
      const dots = document.querySelectorAll('[data-dot]');
      if (slides.length > 1) {
        const show = (i) => {
          slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
          dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        };
        dots.forEach((d) => d.addEventListener('click', () => show(Number(d.dataset.dot))));
      }
    }

    // Swatches couleur
    const swatches = document.querySelectorAll('[data-variant]');
    if (swatches.length > 0) {
      swatches.forEach((s) => {
        s.addEventListener('click', () => {
          swatches.forEach((x) => x.classList.remove('is-active'));
          s.classList.add('is-active');
          // Mettre à jour le label couleur
          const label = document.querySelector('.atelier-product__color-label');
          if (label) label.textContent = 'Couleur : ' + s.getAttribute('aria-label');
        });
      });
    }

    // Wishlist
    const wishlist = document.querySelector('.atelier-product__wishlist');
    if (wishlist) {
      wishlist.addEventListener('click', () => {
        wishlist.classList.toggle('is-active');
        const svg = wishlist.querySelector('svg');
        if (wishlist.classList.contains('is-active')) {
          svg.setAttribute('fill', '#131313');
        } else {
          svg.setAttribute('fill', 'none');
        }
      });
    }
  })();

  /* ============ SWATCHES COULEUR SUR LES CARTES ============ */
  (function () {
    const cards = document.querySelectorAll('.atelier-card');
    cards.forEach((card) => {
      const swatches = card.querySelectorAll('.atelier-card__color');
      if (swatches.length < 2) return;
      swatches.forEach((s) => {
        s.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          swatches.forEach((x) => x.classList.remove('is-active'));
          s.classList.add('is-active');
        });
      });
    });
  })();

  /* ============ GALERIE PRODUIT : navigation molette ============ */
  (function () {
    const main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    const slides = main.querySelectorAll('.atelier-product__slide');
    const dots = document.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    let cur = 0;
    let isScrolling = false;

    const show = (i) => {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === cur));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === cur));
    };

    // Navigation molette (scroll)
    main.addEventListener('wheel', (e) => {
      e.preventDefault();
      if (isScrolling) return;
      isScrolling = true;
      const delta = e.deltaY;
      if (delta > 0) {
        show(cur + 1);
      } else if (delta < 0) {
        show(cur - 1);
      }
      setTimeout(() => { isScrolling = false; }, 600);
    }, { passive: false });

    // Navigation clic sur les dots
    dots.forEach((d) => d.addEventListener('click', () => show(Number(d.dataset.dot))));

    // Navigation clavier
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') show(cur + 1);
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') show(cur - 1);
    });

    // Swipe mobile
    let startY = 0;
    main.addEventListener('touchstart', (e) => { startY = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dy) > 40) show(cur + (dy < 0 ? 1 : -1));
    }, { passive: true });
  })();

  /* ============ CONFIGURATEUR PERSONNALISATION ============ */
  (function () {
    const leather = document.querySelector('[data-perso-leather]');
    if (!leather) return;
    const render = document.querySelector('[data-perso-render]');
    const layer = document.querySelector('[data-perso-layer]');
    const textInput = document.querySelector('[data-perso-text]');
    const POS = {
      'centre':[50,52],'haut-gauche':[24,22],'haut-droit':[76,22],
      'bas-gauche':[24,80],'bas-droit':[76,80],'poche':[72,62],'poignee':[50,14]
    };
    const FONTS = {
      'serif':'Georgia,"Times New Roman",serif',
      'sans':'"Helvetica Neue",Helvetica,Arial,sans-serif',
      'script':'"Segoe Script","Bradley Hand",cursive'
    };
    let libre = false, pos = { x: 50, y: 52 };

    const placer = (x, y, anime) => {
      layer.style.left = x + '%';
      layer.style.top = y + '%';
      if (anime) { layer.classList.add('is-moving'); setTimeout(() => layer.classList.remove('is-moving'), 460); }
    };

    // Texte
    if (textInput && render) {
      textInput.addEventListener('input', () => {
        render.textContent = textInput.value || 'Votre texte';
      });
    }

    // Emplacements
    document.querySelectorAll('[data-perso-places] .perso-place').forEach((b) => {
      b.addEventListener('click', () => {
        document.querySelectorAll('[data-perso-places] .perso-place').forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
        if (b.dataset.pos === 'libre') {
          libre = true;
          leather.style.cursor = 'grab';
        } else {
          libre = false;
          leather.style.cursor = '';
          const p = POS[b.dataset.pos] || POS['centre'];
          pos = { x: p[0], y: p[1] };
          placer(pos.x, pos.y, true);
        }
      });
    });

    // Polices
    document.querySelectorAll('.perso-font').forEach((b) => {
      b.addEventListener('click', () => {
        document.querySelectorAll('.perso-font').forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
        if (render) render.style.fontFamily = FONTS[b.dataset.font] || FONTS['serif'];
      });
    });

    // Couleurs
    document.querySelectorAll('.perso-color').forEach((b) => {
      b.addEventListener('click', () => {
        document.querySelectorAll('.perso-color').forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
        if (render) render.style.color = b.dataset.color;
      });
    });

    // Tailles
    document.querySelectorAll('.perso-size').forEach((b) => {
      b.addEventListener('click', () => {
        document.querySelectorAll('.perso-size').forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
        if (render) render.style.fontSize = b.dataset.size + 'px';
      });
    });

    // Drag & drop en mode libre
    const clamp = (v) => Math.max(6, Math.min(94, v));
    let drag = false;
    const moveTo = (cx, cy) => {
      const r = leather.getBoundingClientRect();
      pos.x = clamp(((cx - r.left) / r.width) * 100);
      pos.y = clamp(((cy - r.top) / r.height) * 100);
      placer(pos.x, pos.y, false);
    };
    leather.addEventListener('mousedown', (e) => { if (!libre) return; drag = true; leather.style.cursor = 'grabbing'; moveTo(e.clientX, e.clientY); e.preventDefault(); });
    document.addEventListener('mousemove', (e) => { if (!drag) return; moveTo(e.clientX, e.clientY); });
    document.addEventListener('mouseup', () => { if (drag) { drag = false; leather.style.cursor = 'grab'; } });
  })();

  /* ============ GALERIE PRODUIT : rotation auto + navigation souris ============ */
  (function () {
    const main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    const slides = main.querySelectorAll('.atelier-product__slide');
    const dots = document.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    let cur = 0;
    let timer = null;
    let isScrolling = false;

    const show = (i) => {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === cur));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === cur));
    };

    const start = () => {
      if (slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(() => show(cur + 1), 4000);
    };

    const stop = () => clearInterval(timer);

    // Navigation molette (scroll)
    main.addEventListener('wheel', (e) => {
      e.preventDefault();
      if (isScrolling) return;
      isScrolling = true;
      const delta = e.deltaY;
      if (delta > 0) {
        show(cur + 1);
      } else if (delta < 0) {
        show(cur - 1);
      }
      setTimeout(() => { isScrolling = false; }, 600);
    }, { passive: false });

    // Navigation tactile
    let startY = 0;
    main.addEventListener('touchstart', (e) => { startY = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dy) > 40) show(cur + (dy < 0 ? 1 : -1));
    }, { passive: true });

    // Navigation clavier
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') show(cur + 1);
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') show(cur - 1);
    });

    // Clic sur les dots
    dots.forEach((d) => d.addEventListener('click', () => show(Number(d.dataset.dot))));

    // Pause au survol
    main.addEventListener('mouseenter', stop);
    main.addEventListener('mouseleave', start);

    // Démarrage
    start();
  })();
});
